require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./parenting-06-14-26.json") })
        }
      }, "path---parenting-06-14-26");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---parenting-06-14-26!./.cache/json/parenting-06-14-26.json
// module id = 851
// module chunks = 231608221292675